import createModel, { Mapped } from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  ...Mapped({
    key: String,
    value: {
      apiKey: String,
      description: String,
      name: String,
    },
  }),
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;

export type TftPowerups = ReturnType<typeof transform>;
